import { createSlice, PayloadAction } from "@reduxjs/toolkit";

export interface BrandingState {
  partnerLogo: string;
  primary: string;
  title: string;
}

const initialState: BrandingState = {
  partnerLogo:
    "https://www.collegewell.com/wp-content/themes/collegewell_custom_theme2022/public/images/logo.svg",
  primary: "#2b3d42",
  title: "CollegeWell",
};

const brandingSlice = createSlice({
  name: "branding",
  initialState,
  reducers: {
    setBranding: (state, action: PayloadAction<BrandingState>) => {
      state.partnerLogo = action.payload.partnerLogo;
      state.primary = action.payload.primary;
      state.title = action.payload.title;
    },
    updatePartnerLogo: (state, action: PayloadAction<string>) => {
      state.partnerLogo = action.payload;
    },
    updatePrimaryColor: (state, action: PayloadAction<string>) => {
      state.primary = action.payload;
    },
    updateTitle: (state, action: PayloadAction<string>) => {
      state.title = action.payload;
    },
  },
});

export const {
  setBranding,
  updatePartnerLogo,
  updatePrimaryColor,
  updateTitle,
} = brandingSlice.actions;
export default brandingSlice.reducer;
